(function () {
  var sentinel = document.querySelector('.collection-load-more__sentinel');
  if (!sentinel) return;

  var batchSize = parseInt(sentinel.dataset.batch, 10) || 12;

  function revealNext() {
    var hidden = document.querySelectorAll('.collection-load-more__hidden');
    if (hidden.length === 0) {
      observer.disconnect();
      sentinel.remove();
      return;
    }

    var toShow = Array.prototype.slice.call(hidden, 0, batchSize);
    toShow.forEach(function (el) {
      el.classList.remove('collection-load-more__hidden');
    });

    if (document.querySelectorAll('.collection-load-more__hidden').length === 0) {
      observer.disconnect();
      sentinel.remove();
    }
  }

  var observer = new IntersectionObserver(
    function (entries) {
      if (entries[0].isIntersecting) {
        revealNext();
      }
    },
    { rootMargin: '200px' }
  );

  observer.observe(sentinel);
})();
